import { ElMenu, ElMenuItem, ElSubMenu } from 'element-plus'
import useUserCommon from '@/hooks/use-user-common.ts'
import { useI18n } from 'i18n-utils'
import './UserMenuComp.scss'

interface UserMenuCompProps {
  onClose?: () => void
}

interface UserMenuCompProps {
  onClose?: () => void
}

export default defineComponent({
  name: 'UserMenuComp',
  props: {
    onClose: Function as PropType<() => void>,
  },
  setup(props: UserMenuCompProps) {
    const { menuList } = useUserCommon()
    const { t } = useI18n()
    const route = useRoute()

    const onMenuClick = () => {
      props.onClose?.()
    }

    return () => (
      <div class="user-menu-comp">
        <ElMenu defaultActive={route.path} router>
          {menuList.value.map((menu) => {
            if (menu.children && menu.children.length > 0) {
              return (
                <ElSubMenu key={menu.title} index={menu.path!}>
                  {{
                    title: () => (
                      <div class={'menu-title'}>
                        {menu.icon}
                        <span class={'menu-title-text'}>{t(menu.title)}</span>
                      </div>
                    ),
                    default: () =>
                      menu!.children!.map((child) => (
                        <ElMenuItem key={child.title} index={child.path} onClick={onMenuClick}>
                          <span class={'menu-title-text'}>{t(child.title)}</span>
                        </ElMenuItem>
                      )),
                  }}
                </ElSubMenu>
              )
            }
            return (
              <ElMenuItem key={menu.title} index={menu.path} onClick={onMenuClick}>
                {{
                  title: () => (
                    <div class={'menu-title'}>
                      {menu.icon && menu.icon}
                      <span class={'menu-title-text'}>{t(menu.title)}</span>
                    </div>
                  ),
                }}
              </ElMenuItem>
            )
          })}
        </ElMenu>
      </div>
    )
  },
})
